export default __webpack_public_path__ + "static/media/category_c1e.532d702c.svg";